import type {
  DeployProgressEvent,
  DeployRequest,
  DeployResponse,
} from '@/app/shared/types/models/deploy.interface';
import { postSseRequest, readSseStream } from '@/app/utils/api/sse-stream';

const baseURL = (config.VUE_APP_ATB_ADMIN_SERVICE_URL || '').replace(
  /[\\/]+$/,
  ''
);

export default {
  async upload(
    request: DeployRequest,
    onProgress?: (_event: DeployProgressEvent) => void
  ): Promise<DeployResponse> {
    const formData = new FormData();
    formData.append('deploymentFile', request.deploymentFile);

    const url = `${baseURL}/bureau-composer/upload/stream`;

    const response = await postSseRequest(url, formData, 'Deployment failed');

    const completeEvent = await readSseStream<
      DeployProgressEvent,
      DeployResponse
    >(response, onProgress, 'Deployment failed');

    if (!completeEvent) {
      throw new Error('Deploy to Engine stream ended without completion event');
    }

    return { deploymentFileName: completeEvent.deploymentFileName };
  },
};
